// extracted by mini-css-extract-plugin
export default {"container":"NewCampaignIsReplied_container__qURGk","header":"NewCampaignIsReplied_header__oZgtK","mainBody":"NewCampaignIsReplied_mainBody__NJHdc"};